// src/components/Map/MapControlPanel.tsx
import React from 'react';
import { useMap } from '../../hooks/useMap';
import { useProcessing } from '../../context/ProcessingContext';

const BASE_MAPS = {
  osm: { label: 'OpenStreetMap', description: 'Default street map view' },
  satellite: { label: 'Satellite', description: 'Aerial imagery' },
  terrain: { label: 'Terrain', description: 'Topographic features' }
};

export const MapControlPanel: React.FC = () => {
  const { settings, updateSettings } = useMap();
  const { state } = useProcessing();
  
  const numPoints = state.rawData?.statistics?.num_points;
  const minValue = state.rawData?.statistics?.z_min;
  const maxValue = state.rawData?.statistics?.z_max;

  return (
    <div className="panel-controls">
      <h3>Map Controls</h3>
      
      <div className="control-group">
        <label>Base Map Style</label>
        <div className="scheme-options">
          {Object.entries(BASE_MAPS).map(([value, {label, description}]) => (
            <label key={value} className="scheme-option">
              <input
                type="radio"
                name="baseMap"
                value={value}
                checked={settings.baseMap === value}
                onChange={(e) => updateSettings({ baseMap: e.target.value as any })}
              />
              <div className="scheme-content">
                <span className="scheme-label">{label}</span>
                <span className="scheme-description">{description}</span>
              </div>
            </label>
          ))}
        </div>
      </div>

      <div className="control-group">
        <label>Contour Layer Opacity</label>
        <div className="control-input">
          <input
            type="range"
            min="0"
            max="1"
            step="0.1"
            value={settings.contourOpacity}
            onChange={(e) => updateSettings({ contourOpacity: Number(e.target.value) })}
          />
          <span className="value">{settings.contourOpacity.toFixed(1)}</span>
        </div>
      </div>

      <div className="control-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={settings.showPoints}
            onChange={(e) => updateSettings({ showPoints: e.target.checked })}
          />
          Show Data Points {numPoints ? `(${numPoints} points)` : ''}
        </label>
      </div>

      {settings.showPoints && minValue !== undefined && maxValue !== undefined && (
        <div className="stats-display">
          <table>
            <tbody>
              <tr>
                <th>Min Value</th>
                <td>{minValue.toFixed(2)}</td>
              </tr>
              <tr>
                <th>Max Value</th>
                <td>{maxValue.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};